/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".fail[_ngcontent-%COMP%]{color:var(--fail-color)!important}.problem[_ngcontent-%COMP%]{color:var(--problem-color)!important}"];
export { styles as styles };

